import { AccountProvenance, type BankAccount } from '../types/bank-account'

const PLACEHOLDER_CURRENCY = 'XXX'

/** Currency is user-editable only when it was NOT reliably reported by the bank:
 *  manually created accounts, or accounts stuck on the XXX placeholder. */
export function isCurrencyEditable(
  account: Pick<BankAccount, 'accountProvenance' | 'currencyIsoCode'>,
): boolean {
  return (
    account.accountProvenance === AccountProvenance.Manual ||
    account.currencyIsoCode === PLACEHOLDER_CURRENCY
  )
}
